module.exports = __webpack_public_path__ + "static/media/arcdev1-mobile.144a2c47.PNG";